import { isUndefined } from "lodash";
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { ReactComponent as MapFillIcon } from '../../icons/map.fill.svg';
import { ILocationItemResponseBody } from "../../types/response/ILocationItemResponseBody";
import { getSiteType } from "../../utils/SiteTypes";
import GridSkeletons from "../skeletons/GridSkeletons";

interface NearbyLocationBoxProps {
  nearByLocations: ILocationItemResponseBody[];
}

const NearbyLocationBox = ({ nearByLocations }: NearbyLocationBoxProps) => {
  const navigate = useNavigate();

  if (isUndefined(nearByLocations)) {
    return <GridSkeletons gridSize={3} skeletonSize={3} skeletonHeight={'73px'} paddingTop={'16px'} />
  }

  return (
    <>
      <div className="mt-[16px] overflow-x-auto hidden-scroll">
        <div className="flex flex-nowrap gap-[10px]">
          {nearByLocations.map((nearBylocation) => {
            return (
              <div
                key={nearBylocation.locationId}
                className="w-[176px] h-[73px] p-[12px] rounded-xl cursor-pointer flex-shrink-0 items-center content-center border border-separator-light-1 dark:border-separator-dark-1"
                onClick={() => navigate(`/locations/${nearBylocation.locationId}`)}
              >
                <div className="flex flex-row text-[15px] font-semibold gap-[2px] text-main-light-2 dark:text-main-dark-2">
                  <MapFillIcon className="min-w-[14px] w-[14px] h-[14px] self-center fill-onTheirty-light dark:fill-onSecondary-dark" />
                  <div className="leading-[18px] truncate">{nearBylocation.name}</div>
                </div>

                {nearBylocation.events?.length > 0 && (
                  <div className="text-[12px] ml-[2px] mt-[9px] leading-[14px] text-main-light-3 dark:text-main-dark-3">
                    {
                      <Trans
                        i18nKey="NearbyLocationBox.nearByLocationEvent"
                        values={{
                          members: nearBylocation.events[0].members?.map((member) => member.name).join(', '),
                          siteType: getSiteType(nearBylocation.siteType).name
                        }}
                        components={{
                          members: <span className="font-semibold" />,
                        }}
                      />
                    }
                    {
                      nearBylocation.events.length > 1 && (
                        <Trans
                          i18nKey="NearbyLocationBox.extraEventCount"
                          values={{
                            count: nearBylocation.events.length - 1
                          }}
                          components={{
                            count: <span className="font-semibold" />
                          }}
                        />
                      )
                    }
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

    </>
  );
};

export default NearbyLocationBox;
